/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-03 14:30:16
 */
import { constantRouter, asyncRouter, resetRouter } from '../../router/index.js'
// 根据role判断路由
function hasPeimisson (role, route) {
  if (route.meta && route.meta.role) {
    return route.meta.role.indexOf(role) >= 0
  } else {
    return true
  }
}
// 过滤路由
function filterAsyncRoutes (routes, role) {
  const res = []
  routes.forEach(ele => {
    const tmp = { ...ele }
    if (hasPeimisson(role, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, role)
      }
      res.push(tmp)
    }
  })
  if (role === 'apply_audit') {
    var array = res
    array = filterGroupAndSingle(res)
    return array
  }
  return res
}

// 区分组队和个人
function filterGroupAndSingle (routes) {
  const isGroup = JSON.parse(sessionStorage.getItem('activityInfo'))
    .finish_assign
  const tmp = []
  const path = isGroup ? '/signAudit' : '/groupAudit'
  routes.forEach(value => {
    if (value.path.search(path) === -1) {
      tmp.push(value)
    }
  })
  return tmp
}

const state = {
  routes: null,
  addRoutes: null
}

const mutations = {
  SET_ROUTES (state, routes) {
    state.routes = routes
    state.addRoutes = constantRouter.concat(routes)
  }
}

const actions = {
  getAsyncRoutes ({ commit, rootState }, role) {
    return new Promise((resolve, reject) => {
      try {
        // const sysType = rootState.uiPermisson.sysType
        // const typeAsyncRouter = asyncRouter(sysType)
        var accessRouter = []
        role = JSON.parse(role)
        role.forEach(item => {
          let routes = filterAsyncRoutes(asyncRouter, item)
          if (routes.length > 0) {
            routes.forEach(route => {
              accessRouter.push(route)
            })
          }
        })
        commit('SET_ROUTES', accessRouter)
        resolve(accessRouter)
      } catch (error) {
        reject(error)
      }
    })
  },
  resetRoutes ({ commit }) {
    return new Promise(resolve => {
      commit('SET_ROUTES', [])
      resetRouter()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js